import React from 'react';
import { motion } from 'framer-motion';
import { LucideIcon } from 'lucide-react';

interface StatsWidgetProps {
  icon: LucideIcon;
  label: string;
  value: string | number;
  color: string;
  bgColor: string;
  index: number;
}

const StatsWidget: React.FC<StatsWidgetProps> = ({ 
  icon: Icon, 
  label, 
  value, 
  color, 
  bgColor, 
  index 
}) => {
  return (
    <motion.div
      initial={{ opacity: 0, y: 20, scale: 0.9 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      whileHover={{ 
        scale: 1.02,
        transition: { duration: 0.2 }
      }}
      className="bg-dark-800/50 backdrop-blur-sm border border-dark-700 rounded-xl p-6 hover:border-dark-600 transition-all duration-300 group cursor-pointer"
    >
      <div className="flex items-center justify-between">
        <div>
          <p className="text-gray-400 text-sm font-medium mb-1">{label}</p>
          <motion.p 
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ duration: 0.5, delay: index * 0.1 + 0.2 }}
            className={`text-2xl font-bold ${color}`}
          >
            {value}
          </motion.p>
        </div>
        <div className={`p-3 rounded-lg ${bgColor} group-hover:scale-110 transition-transform duration-300`}>
          <Icon className={`w-6 h-6 ${color}`} />
        </div>
      </div>
      
      {/* Subtle animation indicator */}
      <div className="mt-4 flex items-center space-x-1">
        <div className={`w-2 h-2 rounded-full ${bgColor} animate-pulse`}></div>
        <span className="text-xs text-gray-500">Live</span>
      </div>
    </motion.div>
  );
};

export default StatsWidget;